

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const EMAILSENDOTP= createAsyncThunk(
  "EmailSendOtp/EmailSendOtp",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const EmailSendOtpSlice = createSlice({
  name: "EmailSendOtpSlice",
  initialState: {
    EmailSendOtp: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfEmailSendOtp: (state) => {
        state.EmailSendOtp.loading = false
        state.EmailSendOtp.error = false
        state.EmailSendOtp.data = []
        state.EmailSendOtp.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(EMAILSENDOTP.fulfilled, (state, action) => {
      state.EmailSendOtp = {
        ...state.EmailSendOtp,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(EMAILSENDOTP.pending, (state, action) => {
      state.EmailSendOtp = {
        ...state.EmailSendOtp,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(EMAILSENDOTP.rejected, (state, action) => {
      state.EmailSendOtp = {
        ...state.EmailSendOtp,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const EmailSendOtpAction = {
    EMAILSENDOTP,
};

export { EmailSendOtpAction };
export default EmailSendOtpSlice.reducer;
export const {setInitialStateOfEmailSendOtp} = EmailSendOtpSlice.actions
